import React from 'react';
import { EmailField } from '../EmailField';
import { PhoneField } from '../PhoneField';
import { SignupFormData, FormErrors } from '../../types';

interface ContactInfoStepProps {
  formData: SignupFormData;
  errors: FormErrors;
  updateField: (field: keyof SignupFormData, value: string | boolean) => void;
  onNext: () => void;
  onPrevious: () => void;
  onStepComplete?: (stepName: string) => void;
}

export const ContactInfoStep: React.FC<ContactInfoStepProps> = ({
  formData,
  errors,
  updateField,
  onNext,
  onPrevious,
  onStepComplete,
}) => {
  const isStepValid = () => {
    return (
      formData.email &&
      formData.phone &&
      !errors.email &&
      !errors.phone
    );
  };

  const handleNext = () => {
    if (isStepValid()) {
      // Track step completion in HubSpot
      if (onStepComplete) {
        onStepComplete('contact_info');
      }
      onNext();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">
          How can we reach you?
        </h1>
        <p className="text-gray-600">
          This becomes your login and our main way to reach you about your account.
        </p>
      </div>

      <div className="space-y-4">
        <EmailField
          id="email"
          name="email"
          label="Email address"
          value={formData.email}
          onChange={(value) => updateField('email', value)}
          error={errors.email}
          required
          placeholder="e.g. sarah.aspinall@smartr365.com"
          helpText="This will be your login email address"
        />

        <PhoneField
          id="phone"
          name="phone"
          label="Phone number"
          value={formData.phone}
          onChange={(value) => updateField('phone', value)}
          error={errors.phone}
          required
          placeholder="e.g. 07123 456 789"
          helpText="We'll use this for account security and important updates"
        />
      </div>

      <div className="flex justify-between pt-4">
        <button
          type="button"
          onClick={onPrevious}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          Previous
        </button>
        
        <button
          type="button"
          onClick={handleNext}
          disabled={!isStepValid()}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Continue
        </button>
      </div>
    </div>
  );
};
